import { message } from 'antd';
import React, { useEffect } from 'react';
import { googleAuthRegister, sendEventAnalyses } from '@/lib/service';
import storage from '@/shared/utils/storage';
import { ANONYMOUS_USER_ID, CREATE_LOGIN_TOKEN } from '@/shared/constants';
import { showRequestError } from '@/shared/utils/tools';
import classNames from 'classnames';
import './index.less';
import { EventName, EventSource } from '@/shared/constants/event';
import { setAnonymousUser } from '@/shared/utils/utils';
import { useConfigProvider } from '@/lib/context';

const GoogleOauthButton = ({
  className,
  getLoginUrl,
}: {
  className?: string;
  getLoginUrl?: (token: string) => string;
}) => {
  const { isMobile } = useConfigProvider();
  useEffect(() => {
    storage.del(CREATE_LOGIN_TOKEN);
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);
    window['googleOauthSingIn'] = function (e) {
      googleAuthRegister({
        idToken: e.credential,
      })
        .then((res) => {
          sendEventAnalyses({
            eventName: EventName.COMMON_VIEW,
            commonType: EventSource.LANDING_PAGE,
            commonContent: 'landing_page_register',
            sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
            field1: 'landing_page_google_oauth_success',
            anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
          });
          window.location.href = getLoginUrl(res.token ?? '');
        })
        .catch((err) => {
          message.destroy();
          showRequestError(err?.response?.data?.message || err?.data?.message || err?.message);
        });
    };
    return () => {
      document.body.removeChild(script);
      delete window['googleOauthSingIn'];
    };
  }, [getLoginUrl, isMobile]);

  return (
    <>
      <div
        id="g_id_onload"
        data-client_id="491562716641-1m7p8m3rea147g8c94m4q169llikplvb.apps.googleusercontent.com"
        data-context="signin"
        data-ux_mode="popup"
        data-callback="googleOauthSingIn"
        data-auto_prompt="false"
      ></div>
      <div
        className={classNames('g_id_signin google-oauth-button', className)}
        data-type="standard"
        data-shape="rectangular"
        data-theme="outline"
        data-text="continue_with"
        data-size="large"
        data-logo_alignment="center"
        onClick={() => {
          sendEventAnalyses({
            eventName: EventName.COMMON_VIEW,
            commonType: EventSource.LANDING_PAGE,
            commonContent: 'landing_page_register',
            sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
            field1: 'landing_page_google_oauth_clicked',
            anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
          });
        }}
      ></div>
    </>
  );
};

export default GoogleOauthButton;
